// This file is auto-generated by ./bin/rails view_component:stimulus_manifest:update
// Run that command whenever you add a new controller in ViewComponent

import { application } from "../javascript/controllers/application";


import HighchartsComponentController from "./highcharts_component_controller"
application.register("highcharts-component", HighchartsComponentController)

import Orgs__DropdownMenuComponentController from "./orgs/dropdown_menu_component_controller"
application.register("orgs--dropdown-menu-component", Orgs__DropdownMenuComponentController)

import Orgs__ModalComponentController from "./orgs/modal_component_controller"
application.register("orgs--modal-component", Orgs__ModalComponentController)

import Orgs__NotificationComponentController from "./orgs/notification_component_controller"
application.register("orgs--notification-component", Orgs__NotificationComponentController)

import PlotlyComponentController from "./plotly_component_controller"
application.register("plotly-component", PlotlyComponentController)
